<template>
  <div class="view">
    <p>当サイトでは個人情報は一切取得しません。</p>
  </div>
</template>

<script>
import { setMeta } from "../lib/meta";

export default {
  mounted() {
    setMeta({
      subtitle: "プライバシーポリシー",
      description: "マルキ鈴菊商店のプライバシーポリシーです。",
      path: this.$route.path,
      image: undefined
    });
  }
};
</script>
